export const getOtpErrorTranslationKey = (error: unknown): string => {
  const status = getErrorStatus(error);

  if (status === 401 || status === 403) {
    return 'authentication.otp.wrong';
  }

  if (status === 503) {
    return 'authentication.otp.provisioningError';
  }

  return 'authentication.otp.serviceError';
};

const getErrorStatus = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null || !('status' in error)) {
    return undefined;
  }

  const { status } = error as { status?: unknown };
  return typeof status === 'number' ? status : undefined;
};
